import { isB2BPatient } from "./b2bUtils";

export const getB2BReturnUrl = (): string | null => {
  if (!isB2BPatient()) {
    return null;
  }
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("returnUrl");
};
